'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  flex-wrap: ', ';\n  max-width: ', ';\n  ', ';\n\n  ', '\n\n  .button {\n    ', '\n\n    ', '\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  flex-wrap: ', ';\n  max-width: ', ';\n  ', ';\n\n  ', '\n\n  .button {\n    ', '\n\n    ', '\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      margin: 0 0 10px 0;\n    '], ['\n      margin: 0 0 10px 0;\n    ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var styles = {
  layout: {
    direction: {
      horizontal: 'row',
      vertical: 'column',
      inverseHorizontal: 'row-reverse',
      inverseVeritcal: 'column-reverse'
    },
    margin: {
      horizontal: 'margin-right: 12px;',
      vertical: 'margin-bottom: 10px;',
      inverseHorizontal: 'margin: 0px 12px;',
      inverseVeritcal: 'margin: 10px; 0'
    }
  },
  align: {
    center: '\n      margin: 0 auto;\n      justify-content: center;\n    ',
    left: 'justify-content: flex-start;',
    right: 'justify-content: flex-end;'
  }
};

var ButtonGroup = exports.ButtonGroup = _styledComponents2.default.div(_templateObject, (0, _helpers.getStyle)(styles.layout.direction, 'layout'), function (props) {
  return props.wrapChildren ? 'wrap' : 'nowrap';
}, function (props) {
  return props.maxWidth + 'px' || 'none';
}, (0, _helpers.getStyle)(styles.align, 'align'), function (props) {
  return !props.inline && _helpers.media.mobile(_templateObject2);
}, (0, _helpers.getStyle)(styles.layout.margin, 'layout'), function (props) {
  return !props.inline && _helpers.media.mobile(_templateObject3);
});
ButtonGroup.displayName = 'ButtonGroup';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-button-group/styles.js
// module id = 2888
// module chunks = 4